import Wrapper from './wrapper';
import { IFieldCreateParams, IFieldsListParams, IFieldUpdateParams, IWrapper } from './types';

class Fields {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Creates a new field in your training set or extraction
   * @param {Object} data
   * @returns {Promise}
   */
  create(data: IFieldCreateParams) {
    return this.wrapper.createField(data);
  }

  /**
   * Gets a paginated list of fields that belong to your training set or extraction
   * @param {[Object]} params - Search parameters
   * @returns {Promise}
   */
  list(params: IFieldsListParams) {
    return this.wrapper.listFields(params);
  }

  /**
   * Gets a single field object
   * @param {string} id
   * @returns {Promise}
   */
  retrieve(id: string) {
    return this.wrapper.retrieveField(id);
  }

  /**
   * Updates a field
   * @param {string} id
   * @param {Object} data
   * @returns {Promise}
   */
  update(id: string, data: IFieldUpdateParams) {
    return this.wrapper.updateField(id, data);
  }

  /**
   * Permanently removes a field from your  training set or extraction.
   * @param {string} id
   * @returns {Promise}
   */
  del(id: string) {
    return this.wrapper.removeField(id);
  }
}

export default Fields;
